import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { Globals } from '../../globals';

@Injectable()
export class ErrorNotificationService {
  private readonly http = inject(HttpClient);
  private readonly globals = inject(Globals);
  private readonly router = inject(Router);

  onOfflineNotify: BehaviorSubject<boolean> = new BehaviorSubject(false);

  connectTimeout = 10; // seconds before trying to connect to the server again
  handle: ReturnType<typeof setInterval> | null = null;

  /**
   * Notify if the user device is on/offline
   * @param offline
   */
  notifyOffline(offline: boolean) {
    // emit event to show the server connection is still offline
    this.onOfflineNotify.next(offline);

    // if the handle is unset, retry the connection, otherwise we're already retrying
    if (this.handle === null || this.handle === undefined) {
      this.retryConnection();
    }
  }

  /**
   * Retry connecting to the rest api
   */
  private retryConnection() {
    this.handle = setInterval(() => {
      this.ping(this);
    }, this.connectTimeout * 1000);
  }

  /**
   * Ping the server to check if it is back online
   * @param self
   */
  private ping(self: ErrorNotificationService) {
    self.pingServer().subscribe(
      (data) => {
        if (data) {
          // clear the interval
          this.handle && clearInterval(this.handle);
          // show that the connection is fixed
          self.onOfflineNotify.next(false);
          // clear the handle
          self.handle = null;
          // reload page, navigate to the current route
          this.router.navigate([this.router.url]);
        } else {
          // if false was returned, the sql server is not availlable, continue pinging
        }
      },
      (error) => {
        // if pinging throws an error, continue pinging
      },
    );
  }

  /**
   * Ping the server
   * Returns true when the server and the ms sql server are availlable, returns false when the ms sql is not availlable
   */
  pingServer(): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtSettings/ping`;
    return this.http.get<boolean>(url).pipe(timeout(2000));
  }
}
